import '../../App.css';
import '../../css/GeneralActivity.css'
import '../../css/BlueActivities.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate} from 'react-router-dom';
import {useContext, useEffect, useState} from 'react';
import Instructions from '../../baseElements/Instructions'
import TopBar from '../../baseElements/TopBar';
import ConfirmButton from "../../baseElements/ConfirmButton";
import {activity_palettes} from '../../themes';
import axios from 'axios';
import SadFeedback from "../../baseElements/SadFeedback";
import HappyFeedback from "../../baseElements/HappyFeedback";
import AnimationOverlay from "../../baseElements/AnimationOverlay";
import {AppContext} from "../../AppContext";
import {checkActivityStatus, delay, generateUrl, getExerciseFromDB, getLog, redirectToExercise, updateCurrentLog} from "../../ActivityManager";
import NextExerciseButton from "../../baseElements/NextExerciseButton";
import NextQuestionButton from "../../baseElements/NextQuestionButton";
import SolutionButton from "../../baseElements/SolutionButton";
import Spinner from "react-bootstrap/Spinner";

axios.defaults.withCredentials = true;
const BACKGROUND_STYLE = activity_palettes.blue.secondary;
const INSTRUCTION_TEXT = "Trova la parola derivata nella frase e scrivila nel riquadro.";

function WriteDerivativeWord() {
    
    const {activityList, setActivityList, currentActivity} = useContext(AppContext);
    
    const navigate = useNavigate();
    
    const [words, setWords] = useState([]);
    const [maxSteps, setMaxSteps] = useState(0);
    const [stepInfo, setStepInfo] = useState(1);
    const [levelInfo, setLevelInfo] = useState(1);
    const [instructionAudioUrl, setInstructionAudioUrl] = useState('');
    const [loading, setLoading] = useState(true);
    
    const [writtenWord, setWrittenWord] = useState('');
    const [currentWord, setCurrentWord] = useState({id: 0, text: '', name: ''});
    const [answered, setAnswered] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [isAnimating, setIsAnimating] = useState(false);
    const [wordColor, setWordColor] = useState('white');
    const [wordBackground, setWordBackground] = useState('#3851C4');
    const [showSolution, setShowSolution] = useState(false);
    const [flowButtons, setFlowButtons] = useState({confirm: true, solution: false, nextExercise: false, nextQuestion: false});
    const [exerciseLog, setExerciseLog] = useState({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    
    const exerciseId = activityList[0][0];
    const exerciseType = activityList[0][1];
    
    function updateButtonFlow(showConfirm, showSolution, showNextExercise, showNextWord) {
        setFlowButtons({confirm: showConfirm, solution: showSolution, nextExercise: showNextExercise, nextQuestion: showNextWord});
    }
    
    function resetStates() {
        setWords([]);
        setMaxSteps(0);
        setStepInfo(1);
        setLevelInfo(1);
        setWrittenWord('');
        setCurrentWord({id: 0, text: '', name: ''});
        setAnswered(false);
        setFeedback('');
        setWordColor('white');
        setWordBackground('#3851C4');
        setShowSolution(false);
        setLoading(true);
        updateButtonFlow(true, false, false, false);
    }
    
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        
        window.onpopstate = (event) => {
            event.preventDefault();
            navigate('/home'); // Navigate directly to /home
        };
        
        return () => {
            window.onpopstate = null;
        };
    }, [navigate]);
    
    useEffect(() => {
        resetStates();
        loadExercise()
            .then((wordsTemporary) => {
                if (wordsTemporary.length > 0) {
                    syncExerciseWithDB(wordsTemporary).then(() => setLoading(false));
                } else {
                    console.error('No words loaded');
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error('Error during loading or syncing:', error);
                setLoading(false);
            });
    }, [navigate]);
    
    async function loadExercise() {
        await delay(750);
        return getExerciseFromDB(activityList)
            .then((response) => {
                if (response.success) {
                    const json = JSON.parse(JSON.stringify(response.data[4]));
                    const level = JSON.parse(JSON.stringify(response.data[3]));
                    let wordsTemporary = [];
                    json.scrittura_parole_derivate.parts.forEach((activity) => {
                        wordsTemporary.push({id: activity.id, text: activity.text, name: activity.solution});
                    });
                    
                    generateUrl("derivate nel testo").then((url) => {
                        setInstructionAudioUrl(url)
                    });
                    
                    setWords(wordsTemporary);
                    setMaxSteps(wordsTemporary.length);
                    setLevelInfo(level);
                    
                    return wordsTemporary;
                } else {
                    console.log(response.errorMess);
                    return [];
                }
            })
            .catch((error) => {
                console.log('Error during loading:', error);
                return [];
            });
    }
    
    function syncExerciseWithDB(wordsTemporary) {
        return new Promise((resolve) => {
            getLog(currentActivity).then((response) => {
                if (response.success) {
                    const exercisesString = JSON.stringify(response.data);
                    const exercises = JSON.parse(exercisesString)[0];
                    if (exercises.some((exercise) => exercise.exercise_id === exerciseId)) {
                        const exercise = exercises.find((exercise) => exercise.exercise_id === exerciseId);
                        let partId = -1;
                        exercise.actions.forEach((action) => {
                            if (action.part_id > partId) {
                                partId = action.part_id;
                            }
                        });
                        partId++;
                        
                        setExerciseLog(exercise);
                        setCurrentWord(wordsTemporary[partId]);
                        setStepInfo(partId + 1);
                    }
                } else {
                    console.log(response.data.errorMess);
                }
                resolve();
            });
        });
    }
    
    function logUserAction(correct) {
        const progress = (currentWord.id + 1) / words.length * 100;
        const timestamp = new Date().toISOString();
        const newAction = {
            part_id: currentWord.id,
            text: currentWord.text,
            writtenWord: currentWord.name,
            correct: correct,
            timestamp: timestamp,
        };
        
        setExerciseLog((prev) => ({
            ...prev,
            exercise_id: exerciseId,
            exercise_type: exerciseType,
            progress: Math.round(progress),
            actions: [...prev.actions, newAction],
        }));
    }
    
    function handleConfirmClick() {
        if(writtenWord.length === 0) {
            return;
        }
        setIsAnimating(true);
        if (writtenWord.toLowerCase() === currentWord.name) {
            logUserAction(true);
            setFeedback('happy');
            setWordColor(activity_palettes.green.secondary);
            setWordBackground(activity_palettes.green.tertiary);
            setTimeout(() => {
                checkIfFinished();
                setIsAnimating(false);
            }, 1250);
        } else {
            logUserAction(false);
            setFeedback('sad');
            setWordColor(activity_palettes.green.error_text);
            setWordBackground(activity_palettes.green.error_background);
            setTimeout(() => {
                updateButtonFlow(false, true, false, false);
                setIsAnimating(false);
            }, 1250);
        }
    }
    
    function handleSolutionClick() {
        setShowSolution(true);
        checkIfFinished();
    }
    
    function handleNextExerciseClick() {
        const temp = [...activityList];
        temp.shift();
        checkActivityStatus(currentActivity, temp).then(
            (response) => {
                try {
                    setActivityList(response);
                    redirectToExercise(response, navigate);
                } catch (error) {
                    console.log(error);
                }
            }
        );
    }
    
    function handleNextQuestionClick() {
        setFeedback('');
        setWrittenWord('');
        setWordColor('white');
        setWordBackground('#3851C4');
        setShowSolution(false);
        setStepInfo(stepInfo + 1);
        setCurrentWord(words[currentWord.id + 1])
        updateButtonFlow(true, false, false, false);
    }
    
    const handleInputChange = (event) => {
        setWrittenWord(event.target.value);
    };
    
    function checkIfFinished() {
        if (currentWord.id < words.length - 1) {
            updateButtonFlow(false, false, false, true);
        } else {
            updateButtonFlow(false, false, true, false);
        }
    }
    
    useEffect(() => {
        if (exerciseLog.exercise_id !== 0) {
            updateCurrentLog(currentActivity, exerciseLog).then();
        }
    }, [exerciseLog]);
    
    if(loading) {
        return (
            <div className='generalActivitiesBackground custom-col-12 tablet-custom-col-12' style={{backgroundColor: BACKGROUND_STYLE}}>
                <Spinner animation="border" variant="light"/>
            </div>
        );
    }
    
    return (
        <div className='generalActivitiesBackground custom-col-12 tablet-custom-col-12' style={{backgroundColor: BACKGROUND_STYLE}}>
            <AnimationOverlay isAnimating={isAnimating}></AnimationOverlay>
            <div className='generalActivitiesPageContent custom-col-11 tablet-custom-col-11'>
                <div className={`generalActivitiesTopBarArea custom-row ${answered ? "disabledElement" : ""}`}>
                    <TopBar levelInfo={levelInfo} stepInfo={stepInfo} maxSteps={maxSteps}> </TopBar>
                    <Instructions hasAudio={false} instructionText={INSTRUCTION_TEXT} instructionAudioUrl={instructionAudioUrl}></Instructions>
                </div>
                <div className={`generalActivitiesGameElementsArea row ${answered ? "disabledElement" : ""}`}>
                    <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                    <SadFeedback feedback={feedback.includes('sad')}></SadFeedback>
                    </div>
                    <div className='generalActivitiesColumnOneColumnLayout custom-col-8'>
                        <div className='frameForText row'>{currentWord.text}</div>
                        <div className='generalActivitiesColumnOneRowLayout custom-col-12'>
                            {showSolution && <div className='generalActivitiesColumnTwoColumnsLayout custom-col-12'>
                                <div className="blueActivitiesArea blueActivitiesTargetTextArea center"
                                     style={{backgroundColor: activity_palettes.green.tertiary, color: activity_palettes.green.secondary, display: showSolution ? 'flex' : 'none'}}>
                                    {currentWord.name}
                                </div>
                            </div>}
                            <div className='generalActivitiesColumnTwoColumnsLayout custom-col-12'>
                                <div className='center blueActivitiesArea blueActivitiesEnabledInputTextArea' style={{backgroundColor: wordBackground}}>
                                    <input className='textFastReadArea'
                                           value={writtenWord}
                                           onChange={handleInputChange}
                                           style={{color: wordColor}}
                                    ></input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                        <HappyFeedback feedback={feedback.includes('happy')}></HappyFeedback>
                    </div>
                </div>
                <div className='generalActivitiesConfirmButtonArea custom-row'>
                    {flowButtons.confirm && <ConfirmButton onClick={handleConfirmClick}/>}
                    {flowButtons.solution && <SolutionButton onClick={handleSolutionClick}/>}
                    {flowButtons.nextExercise && <NextExerciseButton onClick={handleNextExerciseClick}/>}
                    {flowButtons.nextQuestion && <NextQuestionButton onClick={handleNextQuestionClick}/>}
                </div>
            </div>
        </div>
    );
}

export default WriteDerivativeWord;
